import axios from "axios";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { formatErrorMessage } from "./helpers";

export const postRequest = async (token, url, postData, dispatch, loadingFunc, successFunc, errorFunc, includeFile=false) => {
    const headers = {
        Authorization: `Bearer ${token}`,
    };

    if (includeFile) {
        headers['Content-Type'] = 'multipart/form-data';
    }

    if (loadingFunc) {
        dispatch(loadingFunc({ loading: true }));
    }

    try {
        const res = await axios.post(url, postData, { headers })
        if (res.status >= 200 && res.status <= 299) {
            if(loadingFunc!==""){
                dispatch(loadingFunc({loading: false}))
            }
            if(successFunc!==""){
                dispatch(successFunc(res.data.data))
            }
            return {status: res.status, data: res.data}

        }
    } catch (error) {
        if (errorFunc) {
            dispatch(errorFunc({ message: formatErrorMessage(error) }));
        }
        
        if (error.response?.status === 400) {
            if (loadingFunc) {
                dispatch(loadingFunc({ loading: false }));
            }

            return { status: error.response.status, data: error.response.data }
        }
    } finally {
        if (loadingFunc) {
            dispatch(loadingFunc({loading: false}))
        }
    }
};

export const getFileRequest = async (token, dispatch, loadingFunc, errorFunc, folderName, urls) => {
    if (loadingFunc) {
        dispatch(loadingFunc({ loading: true }));
    }

    try {
        const zip = new JSZip();
        const folder = zip.folder(folderName);

        const options = {
            responseType: 'arraybuffer',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        };

        for (const url of urls) {
            if(url.url){
                const response = await axios.get(url.url, options);
                folder.file(`${url.name.replace(/\//g, '_')}.${url.ext}`, response.data);
            }
        }

        const content = await zip.generateAsync({type:"blob"})
        saveAs(content, `${folderName}.zip`);
    } catch (error) {
        if (errorFunc) {
            dispatch(errorFunc({ message: error.message }))
        }
    } finally {
        if (loadingFunc) {
            dispatch(loadingFunc({ loading: false }));
        }
    }

}

export const getRequest = async  (token, url, getData, dispatch, loadingFunc, successFunc, errorFunc)  => {
    //
    if(loadingFunc!==""){
        dispatch(loadingFunc({loading: true}))
    }
    try {
        const res = await axios.get(`${url}`,
            {
                params: getData,
                headers:{
                'Content-type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            }})
        if (res.status >= 200 && res.status <= 299) {
            if(loadingFunc!==""){
                dispatch(loadingFunc({loading: false}))
            }
            if(successFunc!==""){
                dispatch(successFunc(res.data.data))
            }
            return {status: res.status, data: res.data}
        }
    }
    catch (error) {
        let msg = formatErrorMessage(error)
            if(errorFunc!==""){
                dispatch(errorFunc({message: msg }))
            }
        if(error?.response?.status === 400){
            if(loadingFunc!==""){
                dispatch(loadingFunc({loading: false}))
            }
            return {status: error.response.status, data: error.response.data}
        }
    }

    if(loadingFunc!==""){
        dispatch(loadingFunc({loading: false}))
     }
}
